// @ts-nocheck
import React, {useEffect, useState} from 'react'
import {Link, useParams} from 'react-router-dom'
import {format} from 'date-fns'

import moment from 'moment'
import {parsePostContent, formatParsedContent} from '../../helper/contentParser'

const AdsDetailsViewOverview = ({post, loading, id}) => {
  const [link, setLink] = useState('')
  const [parsedContent, setParsedContent] = useState('')
  
  useEffect(() => {
    const init = () => {
      var description = post?.content
      
      if (description) {
        // Parse the content for better display
        const parsed = parsePostContent(description)
        const formatted = formatParsedContent(parsed)
        setParsedContent(formatted)
        
        // Extract teaching link for separate display
        const linkRegex = /<link>(.*?)<\/link>/
        const match = description?.match(linkRegex)
        const l = match ? match[1] : null
        setLink(l || parsed.appLink || '')
      }
    }

    if (post) {
      init()
    }
  }, [post])
  return (
    <>
      <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
        <div className='card-header cursor-pointer'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>Post Details</h3>
          </div>
        </div>

        {/* Full Name */}
        <div className='card-body p-9'>
          {/* Ad Name */}
          {/* <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Poster Name</label>

            <div className='col-lg-8 fv-row'>
              <span className='fw-bold fs-6'>
                {post?.posted_by?.first_name
                  ? post?.posted_by?.first_name + ' ' + post?.posted_by?.last_name
                  : 'Loading'}
              </span>
            </div>
          </div>

          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Poster Email</label>

            <div className='col-lg-8 fv-row'>
              <span className='fw-bold fs-6'>
                {post?.posted_by?.email ? post?.posted_by?.email : 'Loading'}
              </span>
            </div>
          </div> */}

          {/* Contact */}
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>
              Content
              <i
                className='fas fa-exclamation-circle ms-1 fs-7'
                data-bs-toggle='tooltip'
                title='Phone number must be active'
              ></i>
            </label>

            <div className='col-lg-8 d-flex align-items-center'>
              <span className='fw-bolder fs-6 me-2'>
                <div
                  dangerouslySetInnerHTML={{__html: parsedContent || 'Loading...'}}
                  className='html-content text-wrap'
                  style={{width: '600px'}}
                />
              </span>
            </div>
          </div>

          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>
              Teaching Link
              <i
                className='fas fa-exclamation-circle ms-1 fs-7'
                data-bs-toggle='tooltip'
                title='Phone number must be active'
              ></i>
            </label>

            <div className='col-lg-8 d-flex align-items-center'>
              <span className='fw-bolder fs-6 me-2'>
                {link ? (
                  <a href={link} target="_blank" rel="noopener noreferrer" className="text-primary">
                    {link}
                  </a>
                ) : (
                  <span className="text-muted">No teaching link added</span>
                )}
              </span>
            </div>
          </div>

          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Likes </label>

            <div className='col-lg-8 fv-row'>
              <span className='fw-bold fs-6'>{post?.likesCount ? post?.likesCount : '0'}</span>
            </div>
          </div>

          {/* Gender */}
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Shares</label>

            <div className='col-lg-8 fv-row'>
              <span className='fw-bold fs-6'>{post?.sharesCount ? post?.sharesCount : '0'}</span>
            </div>
          </div>

          {/* Start Time */}
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Created At</label>

            <div className='col-lg-8 fv-row'>
              <span className='fw-bold fs-6'>
                {post?.createdAt ? moment(new Date(post?.createdAt)).format('LL') : 'Loading'}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className='row gy-10 gx-xl-10'>
        <div className='col-xl-6'>
          {/* <ChartsWidget1 className='card-xxl-stretch mb-5 mb-xl-10' /> */}
        </div>

        <div className='col-xl-6'>
          {/* <TablesWidget1 className='card-xxl-stretch mb-5 mb-xl-10' /> */}
        </div>
      </div>

      <div className='row gy-10 gx-xl-10'>
        <div className='col-xl-6'>
          {/* <ListsWidget5 className='card-xxl-stretch mb-5 mb-xl-10' /> */}
        </div>

        <div className='col-xl-6'>
          {/* <TablesWidget5 className='card-xxl-stretch mb-5 mb-xl-10' /> */}
        </div>
      </div>
    </>
  )
}

export default AdsDetailsViewOverview
